goog.provide("shadow.js.shim.module$$mui$material$TableContainer$default");
shadow.js.shim.module$$mui$material$TableContainer$default = shadow.js.shim.module$$mui$material$TableContainer.default;
